module.exports = __webpack_public_path__ + "img/ico_view_arrow_right.8bdb1095.svg";